<template>
  <page-view
    class="statistics"
    title="Account statistics"
    backLink="/dashboard"
    backText="Back to Dashboard"
    :key="$route.hash"
    ref="pageview"
  >
    <div class="d-f f-1 ai-c jc-c" v-if="state === 'loading'">
      <div class="loading-spinner large"></div>
    </div>
    <div v-else>
      <card-minimal-title title="Summary">
        <!--<template v-slot:right-side>
          <span class="link blue" @click="changeSummaryState()">
            {{ summaryState === 'total' ? 'Show average' : 'Show total' }}
          </span>
        </template>-->
      </card-minimal-title>
      <div class="d-f f-g fd-r f-wrap f-wrap-2 m-b-2">
        <template v-for="(keyData, key) in summaryStats">
          <KeyAdvanced
            v-if="keyData.show"
            :key="key"
            :label="keyData.label"
            :icon="keyData.icon"
            :total="keyData.total"
            :live="keyData.live"
            :recorded="keyData.recorded"
          />
          <!--
            :totalAgainst="key !== 'pageview' ? totalStats.pageview.total : false"
            :tooltip="keyData.tooltip"
            :showLiveRecordedPercentage="true"
          -->
        </template>
      </div>
      <div class="d-f fd-c fd-md-r f-g fd-md-r-f-1" v-if="yearStats.data || monthStats.data">
        <card-minimal subtitle="Viewers per year" subtitleIcon="graph" class="flex" v-if="yearStats.data">
          <template slot="subtitle-slot">
            <small class="ml-a p-l-2">Updates monthly</small>
          </template>
          <div style="max-height: 200px">
            <Graph type="bar" :data="{ labels: yearStats.labels, datasets: yearStats.datasets }" :showYLabels="false" />
          </div>
        </card-minimal>
        <card-minimal subtitle="Viewers per month"  subtitleIcon="graph" class="flex" v-if="monthStats.data">
          <template slot="subtitle-slot">
            <small class="ml-a p-l-2">Updates weekly</small>
          </template>
          <div style="max-height: 200px">
            <Graph type="bar" :data="{ labels: monthStats.labels, datasets: monthStats.datasets }" :showYLabels="false" />
          </div>
        </card-minimal>
      </div>
      <!--<card-minimal-title title="Engagement" />
      <div class="d-f f-g fd-r f-wrap f-wrap-3 m-b-2">
        <KeyAdvanced v-for="(keyData, key) in engagementStats" :key="key" :label="keyData.label" :icon="keyData.icon" :total="parseFloat((keyData.total / totalStats.pageview.total).toFixed(2))" :renameTotal="' '" :hideRecorded="true" :hideLive="true" />
      </div>-->
      <card-minimal title="Statistics per day" :subtitle="` `" subtitleIcon="line-graph-24" class="graph m-t-4 p-b-3">
        <template slot="subtitle-slot">
          <FormDropdown :items="timeera" @input="timeera = $event.value" class="minimal inline blue m-l-2" />
          <small class="ml-a p-l-2">Updates once an hour</small>
        </template>
        <Graph :data="{ labels: dayStats.labels, datasets: dayStats.datasets }" :options="dayStats.options" ref="dayGraph" />
        <KeyValues>
          <template v-for="(dataset, key) in dayStats.graph">
            <Key v-if="dataset.show" :key="`${key}-${dayStats.timeEra}`" :color="dataset.colorName" :icon="dataset.icon" :active="dayStats.activeDatasets.includes(key)" :total="parseInt(dataset.total, 10)" :label="dataset.label" :afterLabel="dataset.afterLabel" @click.native="toggleStatisticsDataset('dayStats', key)" />
          </template>
        </KeyValues>
      </card-minimal>
      <card-minimal title="Previous 3 completed broadcasts" class="m-t-4 broadcasts" v-if="broadcastStats.broadcasts.length > 0">
        <div class="broadcast" @click="$router.push(`/broadcast/${broadcast.id}/statistics`)" :key="broadcast.id" v-for="broadcast in broadcastStats.broadcasts">
          <div class="image-wrapper">
            <div class="image" :style="`${broadcast.images && broadcast.images.length > 0 ? `background-image: url(https://${fqdn}.streamify.io/images/h/200/${broadcast.images[0]})` : ''}`"></div>
          </div>
          <div class="info">
            <p class="title">{{ broadcast.actual_start_time | friendly_short_date }}</p>
            <span>{{ broadcast.title }}</span>
          </div>
          <div class="stats ml-a">
            <p class="title">Viewers</p>
            <span>{{ broadcast.stats }}</span>
          </div>
        </div>
      </card-minimal>
    </div>
  </page-view>
</template>

<script>

import moment from 'moment';
import { AnalyticsService } from '@/services/analytics.service';
import KeyAdvanced from '@/components/Statistics/KeyAdvanced.vue';
import KeyValues from '@/components/Statistics/KeyValues.vue';
import Key from '@/components/Statistics/Key.vue';

export default {
  components: {
    KeyAdvanced,
    KeyValues,
    Key,
  },
  computed: {
    /**
     * Return the current config in store
     * @returns {Object}
     */
    lvspConfig() {
      return this.$store.getters['Play/lvspConfig'];
    },
    summaryStats() {
      if (this.summaryState === 'total') {
        return this.totalStats;
      }

      let averageStats = JSON.parse(JSON.stringify(this.totalStats));

      averageStats = {
        pageview: {
          ...averageStats.pageview,
          total: (averageStats.pageview.total / Math.random()).toFixed(0),
          live: (averageStats.pageview.live / Math.random()).toFixed(0),
          recorded: (averageStats.pageview.recorded / Math.random()).toFixed(0),
        },
        add_to_cart: {
          ...averageStats.add_to_cart,
          total: (averageStats.add_to_cart.total / Math.random()).toFixed(0),
          live: (averageStats.add_to_cart.live / Math.random()).toFixed(0),
          recorded: (averageStats.add_to_cart.recorded / Math.random()).toFixed(0),
        },
        view_product: {
          ...averageStats.view_product,
          total: (averageStats.view_product.total / Math.random()).toFixed(0),
          live: (averageStats.view_product.live / Math.random()).toFixed(0),
          recorded: (averageStats.view_product.recorded / Math.random()).toFixed(0),
        },
        jump_to_product: {
          ...averageStats.jump_to_product,
          total: (averageStats.jump_to_product.total / Math.random()).toFixed(0),
          live: (averageStats.jump_to_product.live / Math.random()).toFixed(0),
          recorded: (averageStats.jump_to_product.recorded / Math.random()).toFixed(0),
        },
      };

      return averageStats;
    },
    liveShoppingEnabledAndActive() {
      return this.activeSubscription && this.liveshoppingEnabled;
    },
    addToCartEnabled() {
      if (!this.liveShoppingEnabledAndActive) {
        return false;
      }

      const { shoppingSettings: { provider } = {} } = this;
      return this.lvspConfig?.events.includes('cart.add') || this.lvspConfig?.urls.product_add_to_cart !== 'undefined' || provider.includes('shopify');
    },
    goToProductDayAboveZero() {
      return this.dayStats.graph.go_to_product.total > 0;
    },
    goToProductTotalAboveZero() {
      return this.totalStats.go_to_product.total > 0;
    },
    timeera: {
      get() {
        return [
          { value: 'past-7', string: 'Past 7 days' },
          { value: 'past-30', string: 'Past 30 days' },
        ].map(item => ({ ...item, selected: item.value === this.dayStats.timeEra }));
      },
      async set(value) {
        const [, days] = value.split('-');
        this.dayStats.timeEra = value;
        this.dayStats.from = moment().subtract(parseInt(days, 10), 'days').format('YYYY-MM-DD');

        await this.getStatistics('dayStats');
        const datasets = this.dayStats.activeDatasets;
        this.dayStats.activeDatasets = [];
        this.dayStats.datasets = [];
        this.$nextTick(() => {
          datasets.forEach(dataset => this.toggleStatisticsDataset('dayStats', dataset));
        });
        // eslint-disable-next-line
        this.dayStats.graph.avg_view_time.total = this.dayStats.graph.avg_view_time.total / [...new Map(this.dayStats.graph.avg_view_time.data.map(v => [v.date, v])).values()].length
      },
    },
  },
  methods: {
    changeSummaryState() {
      if (this.summaryState === 'total') {
        this.summaryState = 'average';
      } else {
        this.summaryState = 'total';
      }
    },
    async getTotalStatistics() {
      let data;
      try {
        data = await AnalyticsService.getAccountTotalStatistics();
      } catch (e) {
        return;
      }

      // Clear and setup datasets
      Object.keys(this.totalStats).forEach((dataset) => {
        this.totalStats[dataset].data = [];
        this.totalStats[dataset].total = 0;
      });

      const activeDatasets = [];
      const engagementKeys = Object.keys(this.engagementStats);
      data.forEach((event) => {
        if (typeof this.totalStats[event.event] !== 'undefined') {
          if (!activeDatasets.includes(event.event)) {
            this.totalStats[event.event].show = true;
            activeDatasets.push(event.event);
          }

          if (['live', 'recorded'].includes(event.state)) {
            this.totalStats[event.event].total += event.sum;
            if (event.state === 'live') {
              this.totalStats[event.event].live = event.sum;
            } else if (event.state === 'recorded') {
              this.totalStats[event.event].recorded = event.sum;
            }
          }
        }

        engagementKeys.forEach((key) => {
          if (this.engagementStats[key].collect.includes(event.event) && ['live', 'recorded'].includes(event.state)) {
            this.engagementStats[key].total += event.sum;
          }
        });
      });

      Object.keys(this.totalStats).forEach((dataset) => {
        if (typeof this.totalStats[dataset].showIf !== 'undefined' ? this[this.totalStats[dataset].showIf] : true) {
          this.totalStats[dataset].show = true;
        }
      });
    },
    /**
     * Get statistics between two dates and set data to the given type
     * @param {String} statsType
     * @returns {Void}
     */
    async getStatistics(statsType) {
      if (!statsType || typeof this[statsType] === 'undefined') {
        return;
      }

      const {
        dateFormat,
        diffFormat,
        labelFormat,
      } = this[statsType];

      const from = moment(this[statsType].from);
      const fromAnalytics = moment(this[statsType].from);
      const to = moment(this[statsType].to);

      if (statsType === 'dayStats') {
        fromAnalytics.add(1, 'day');
      }

      const data = await AnalyticsService.getAccountStatistics(fromAnalytics.format(dateFormat), to.format(dateFormat));
      this[statsType].data = data;

      const labelsLength = Math.abs(from.diff(to, diffFormat));
      const labels = [];

      if (statsType === 'yearStats') {
        labels.push(from.format(labelFormat));
      }

      for (let i = 0; i < labelsLength; i += 1) {
        labels.push(from.add(1, diffFormat).format(labelFormat));
      }

      this[statsType].labels = labels;

      // Clear and setup datasets
      Object.keys(this[statsType].graph).forEach((dataset) => {
        this[statsType].graph[dataset].data = [];
        this[statsType].graph[dataset].total = 0;
      });

      const sortedDatasets = [];
      data.forEach((event) => {
        if (typeof this[statsType].graph[event.event] !== 'undefined') {
          if (['recorded', 'live'].includes(event.state)) {
            if (!sortedDatasets.includes(event.event)) {
              // this[statsType].graph[event.event].show = true;
              sortedDatasets.push(event.event);
            }
            this[statsType].graph[event.event].data = this[statsType].graph[event.event].data.concat(event.dataset);
            this[statsType].graph[event.event].total += event.sum;
          }
        }
      });

      Object.keys(this[statsType].graph).forEach((dataset) => {
        if (typeof this[statsType].graph[dataset].showIf !== 'undefined' ? this[this[statsType].graph[dataset].showIf] : true) {
          this[statsType].graph[dataset].show = true;
        }
      });
    },
    /**
     * Toggle dayStatistics datasets
     * @param {String} statsType
     * @param {String} dataset
     * @returns {Void}
     */
    toggleStatisticsDataset(statsType, dataset) {
      const from = moment(this[statsType].from);
      const to = moment(this[statsType].to);
      const diff = Math.abs(from.diff(to, this[statsType].diffFormat));

      const index = this[statsType].datasets.findIndex(d => d.label === this[statsType].graph[dataset].label);
      if (index >= 0) {
        if (this[statsType].datasets.length === 1) {
          return;
        }

        this[statsType].datasets.splice(index, 1);
        this[statsType].activeDatasets.splice(this[statsType].activeDatasets.indexOf(dataset), 1);
        return;
      }

      // Add some data
      const data = new Array(diff + 1).fill().map(() => 0);
      this[statsType].graph[dataset].data.forEach((entry) => {
        const d = Math.abs(moment(from.format(this[statsType].dateFormat)).diff(new Date(entry.date), this[statsType].diffFormat));
        data[statsType === 'yearStats' ? d : d - 1] += entry.value;
      });

      /*
      // if we want the graph to go up up and away
      for (let i = 0; i < data.length; i += 1) {
        if (i !== 0) {
          data[i] = data[i - 1] + data[i];
        }
      }
      */

      this[statsType].datasets.push({
        backgroundColor: this[statsType].graph[dataset].color,
        borderColor: this[statsType].graph[dataset].color,
        label: this[statsType].graph[dataset].label,
        data,
        tension: 0.2,
        beginAtZero: true,
        pointRadius: 0,
        pointHitRadius: 20,
      });

      this[statsType].activeDatasets.push(dataset);
    },
    async getBroadcastsStatistics() {
      const {
        broadcasts,
      } = await this.$store.dispatch('Broadcasts/getBroadcasts', {
        skipConf: true,
        skipState: true,
        page: 1,
        per_page: 3,
        sort: 'scheduled_start_time',
        direction: 'desc',
        type: 'past',
      });

      for (let i = 0; i < broadcasts.length; i += 1) {
        const {
          id,
          metadata: {
            title,
          },
          images,
          actual_start_time,
        } = broadcasts[i];

        // eslint-disable-next-line
        const broadcastStats = await AnalyticsService.getBroadcastTotalStatistics(id);

        this.broadcastStats.broadcasts.push({
          id,
          title,
          images,
          stats: broadcastStats.reduce((a, b) => (b.event === 'pageview' && b.state !== 'upcoming' ? a + b.sum : a), 0),
          actual_start_time,
        });
      }
    },
  },
  data() {
    return {
      summaryState: 'total',
      totalStats: {
        pageview: {
          icon: 'eye-24',
          label: 'Viewers',
          show: true,
          total: 0,
          live: 0,
          recorded: 0,
          tooltip: 'oooh, viwers är bra att veta om',
        },
        add_to_cart: {
          icon: 'shoppingbag-24',
          label: 'Add to cart',
          show: false,
          showIf: 'addToCartEnabled',
          total: 0,
          live: 0,
          recorded: 0,
          tooltip: 'oooh, viwers är bra att veta om',
        },
        go_to_product: {
          icon: 'shoppingbag-24',
          label: 'Go to product',
          show: false,
          showIf: 'goToProductTotalAboveZero',
          total: 0,
          live: 0,
          recorded: 0,
        },
        view_product: {
          icon: 'shoppingbag-24',
          label: 'View product',
          show: false,
          showIf: 'liveShoppingEnabledAndActive',
          total: 0,
          live: 0,
          recorded: 0,
        },
        jump_to_product: {
          icon: 'shoppingbag-24',
          label: 'Jump to product',
          show: false,
          showIf: 'liveShoppingEnabledAndActive',
          total: 0,
          live: 0,
          recorded: 0,
        },
      },
      engagementStats: {
        total: {
          icon: 'eye-24',
          label: 'Total',
          total: 0,
          collect: ['add_to_cart', 'view_product', 'jump_to_product', 'messages', 'reactions'],
        },
        product: {
          icon: 'shoppingbag-24',
          label: 'Product',
          show: false,
          total: 0,
          collect: ['add_to_cart', 'view_product', 'jump_to_product'],
        },
        feedback: {
          icon: 'shoppingbag-24',
          label: 'Feedback',
          total: 0,
          collect: ['messages', 'reactions'],
        },
      },
      yearStats: {
        data: null,
        datasets: [],
        labels: [],
        activeDatasets: [],
        graph: {
          pageview: {
            color: '#007FFF',
            colorName: 'blue',
            icon: 'eye-24',
            label: 'Viewers',
            show: true,
            total: 0,
            data: [],
          },
        },
        from: moment().year('2021').format('YYYY'),
        to: moment().format('YYYY'),
        dateFormat: 'YYYY',
        diffFormat: 'years',
        labelFormat: 'YYYY',
      },
      monthStats: {
        num: 0,
        max: 6,
        data: null,
        datasets: [],
        labels: [],
        activeDatasets: [],
        graph: {
          pageview: {
            color: '#007FFF',
            colorName: 'blue',
            icon: 'eye-24',
            label: 'Viewers',
            show: true,
            total: 0,
            data: [],
          },
        },
        from: moment().subtract(6, 'months').format('YYYY-MM'),
        to: moment().format('YYYY-MM'),
        dateFormat: 'YYYY-MM',
        diffFormat: 'months',
        labelFormat: 'MMM',
      },
      dayStats: {
        timeEra: 'past-30',
        options: {
          scales: {
            y: {
              ticks: {
                display: true,
              },
            },
          },
        },
        data: null,
        graph: {
          pageview: {
            color: '#007FFF',
            colorName: 'blue',
            icon: 'eye-24',
            label: 'Viewers',
            show: true,
            total: 0,
            data: [],
          },
          add_to_cart: {
            color: '#00B5D6',
            colorName: 'ocean',
            icon: 'shoppingbag-24',
            label: 'Add to cart',
            show: false,
            showIf: 'addToCartEnabled',
            total: 0,
            data: [],
          },
          go_to_product: {
            color: '#00B5D6',
            colorName: 'ocean',
            icon: 'shoppingbag-24',
            label: 'Go to product',
            show: false,
            showIf: 'goToProductDayAboveZero',
            total: 0,
            data: [],
          },
          view_product: {
            color: '#00CF4D',
            colorName: 'green',
            icon: 'shoppingbag-24',
            label: 'View product',
            show: false,
            showIf: 'liveShoppingEnabledAndActive',
            total: 0,
            data: [],
          },
          jump_to_product: {
            color: '#FF4C4C',
            colorName: 'peach',
            icon: 'shoppingbag-24',
            label: 'Jump to product',
            show: false,
            showIf: 'liveShoppingEnabledAndActive',
            total: 0,
            data: [],
          },
          avg_view_time: {
            color: '#FF00DF',
            colorName: 'pink',
            icon: 'clock-fill-24',
            label: 'Avg view time',
            afterLabel: 'min',
            show: false,
            total: 0,
            data: [],
          },
        },
        labels: [],
        datasets: [],
        activeDatasets: [],
        from: moment().subtract(30, 'days').format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
        dateFormat: 'YYYY-MM-DD',
        diffFormat: 'days',
        labelFormat: 'DD/M',
      },
      broadcastStats: {
        broadcasts: [],
      },
      state: 'loading',
    };
  },
  async mounted() {
    const {
      broadcasts: [firstBroadcast],
    } = await this.$store.dispatch('Broadcasts/getBroadcasts', {
      skipConf: true,
      skipState: true,
      page: 1,
      per_page: 1,
      sort: 'scheduled_start_time',
      direction: 'asc',
      type: 'past',
    });

    let getYearStats = false;

    if (firstBroadcast) {
      const monthDiff = moment().diff(moment(firstBroadcast.scheduled_start_time), 'months');
      if (monthDiff > 0) {
        const max = monthDiff <= this.monthStats.max ? monthDiff : this.monthStats.max;
        this.monthStats.from = moment().subtract(max, 'months').format('YYYY-MM');
      }

      const firstYear = moment(firstBroadcast.scheduled_start_time).year();
      this.yearStats.from = firstYear < 2021 ? '2021' : `${firstYear}`;
      if (firstYear !== moment().year() || monthDiff > Math.abs(moment(this.monthStats.from).diff(moment(), 'months'))) {
        getYearStats = true;
      }
    }

    await this.getTotalStatistics();
    await this.getStatistics('dayStats');
    // eslint-disable-next-line
    this.dayStats.graph.avg_view_time.total = this.dayStats.graph.avg_view_time.total / [...new Map(this.dayStats.graph.avg_view_time.data.map(v => [v.date, v])).values()].length
    await this.getStatistics('monthStats');
    if (getYearStats) {
      await this.getStatistics('yearStats');
    }
    await this.getBroadcastsStatistics();

    this.$nextTick(() => {
      this.toggleStatisticsDataset('dayStats', 'pageview');
      this.toggleStatisticsDataset('monthStats', 'pageview');
      this.toggleStatisticsDataset('yearStats', 'pageview');
    });

    this.state = '';
  },
};
</script>

<style lang="scss">
.statistics {
  .broadcasts {
    .card-content {
      padding: 15px;
    }
  }
  .broadcast {
    align-items: center;
    display: flex;

    &:not(:last-child) {
      margin-bottom: 15px;
    }

    &:hover {
      cursor: pointer;
    }

    .info, .stats {
      padding: 0 15px;
    }

    .stats {
      text-align: center;
    }

    .title {
      color: #5c5e61;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.2;

      @media (min-width: 768px) {
        font-size: 18px;
      }
    }

    span {
      font-size: 16px;
      line-height: 1.2;

      @media (min-width: 768px) {
        font-size: 20px;
      }
    }

    .image-wrapper {
      .image {
        background-color: #000000;
        background-position: 50% 50%;
        background-size: contain;
        background-repeat: no-repeat;
        height: 45px;
        width: 80px;
        border-radius: 6px;
        transition: height .3s, width .3s;

        @media (min-width: 768px) {
          height: 70px;
          width: 124px;
        }
      }
    }
  }
}
</style>
